import React from 'react';
import Combainblog from '../Components/Topbarblog/One';
import Combaintop from '../Components/Combaintop/Top';
import Combainbottom from '../Components/Combainbottom/Combainbottom';
import Breadcrumbs from '../Components/banner/New-banner';
import AllCategoriesPage from '../Components/Topbarblog/BlogPage';
function Blogpage() {
    return (
        <>

            <Combaintop />
            <Breadcrumbs/>
            {/* <Combainblog /> */}
            <AllCategoriesPage/>
            <Combainbottom />
        </>
    );
}

export default Blogpage;
